// export type checkDisable = true;

import { t } from 'i18next';

export const checkboxGroups = () => ({
  ontology: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '1000',
      name: 'OntologiesCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '1001',
      name: 'OntologiesRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '1002',
      name: 'OntologiesUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '1003',
      name: 'OntologiesDelete',
      // disabled: true,
    },
  ],
  event: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '2000',
      name: 'EventCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '2001',
      name: 'EventRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '2002',
      name: 'EventUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '2003',
      name: 'EventDelete',
      // disabled: true,
    },
  ],
  userRights: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '3000',
      name: 'UserRightsCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '3001',
      name: 'UserRightsRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '3002',
      name: 'UserRightsUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '3003',
      name: 'UserRightsDelete',
      // disabled: true,
    },
  ],
  users: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '4000',
      name: 'UsersCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '4001',
      name: 'UsersRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '4002',
      name: 'UsersUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '4003',
      name: 'UsersDelete',
      // disabled: true,
    },
  ],
  incidentFolder: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '5000',
      name: 'IncidentFolderCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '5001',
      name: 'IncidentFolderRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '5002',
      name: 'IncidentFolderUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '5003',
      name: 'IncidentFolderDelete',
      // disabled: true,
    },
  ],
  incident: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '6000',
      name: 'IncidentCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '6001',
      name: 'IncidentRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '6002',
      name: 'IncidentUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '6003',
      name: 'IncidentDelete',
      // disabled: true,
    },
  ],
  injection: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '7000',
      name: 'InjectionCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '7001',
      name: 'InjectionRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '7002',
      name: 'InjectionUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '7003',
      name: 'InjectionDelete',
      // disabled: true,
    },
  ],
  action: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '8000',
      name: 'ActionCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '8001',
      name: 'ActionRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '8002',
      name: 'ActionUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '8003',
      name: 'ActionDelete',
      // disabled: true,
    },
  ],
  outcome: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '9000',
      name: 'OutcomeCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '9001',
      name: 'OutcomeRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '9002',
      name: 'OutcomeUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '9003',
      name: 'OutcomeDelete',
      // disabled: true,
    },
  ],
  observationTask: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '10000',
      name: 'ObservationTaskCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '10001',
      name: 'ObservationTaskRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '10002',
      name: 'ObservationTaskUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '10003',
      name: 'ObservationTaskDelete',
      // disabled: true,
    },
  ],
  trainingObjective: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '11000',
      name: 'ObjectiveCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '11001',
      name: 'ObjectiveRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '11002',
      name: 'ObjectiveUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '11003',
      name: 'ObjectiveDelete',
      // disabled: true,
    },
  ],
  configurationChangeRequest: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '15000',
      name: 'ConfigurationChangeRequestCreate',
      // disabled: true,
      style: { color: 'white' },
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '15001',
      name: 'ConfigurationChangeRequestRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '15002',
      name: 'ConfigurationChangeRequestUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '15003',
      name: 'ConfigurationChangeRequestDelete',
      // disabled: true,
    },
  ],
  troubleTicket: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '16000',
      name: 'TroubleTicketCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '16001',
      name: 'TroubleTicketRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '16002',
      name: 'TroubleTicketUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '16003',
      name: 'TroubleTicketDelete',
      // disabled: true,
    },
  ],
  // registry: [
  //   {
  //     label: t('administration.userRights.permissions.add'),
  //     value: '23000',
  //     name: 'RegistryCreate',
  //     // disabled: true,
  //   },
  //   {
  //     label: t('administration.userRights.permissions.read'),
  //     value: '23001',
  //     name: 'RegistryRead',
  //     // disabled: false,
  //   },
  //   {
  //     label: t('administration.userRights.permissions.modify'),
  //     value: '23002',
  //     name: 'RegistryUpdate',
  //     // disabled: true,
  //   },
  //   {
  //     label: t('administration.userRights.permissions.delete'),
  //     value: '23003',
  //     name: 'RegistryDelete',
  //     // disabled: true,
  //   },
  // ],
  setting: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '24000',
      name: 'SettingCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '24001',
      name: 'SettingRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '24002',
      name: 'SettingUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '24003',
      name: 'SettingDelete',
      // disabled: true,
    },
  ],
  technicalSupportRequest: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '22000',
      name: 'TechnicalSupportRequestCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '22001',
      name: 'TechnicalSupportRequestRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '22002',
      name: 'TechnicalSupportRequestUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '22003',
      name: 'TechnicalSupportRequestDelete',
      // disabled: true,
    },
  ],
  state: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '12000',
      name: 'StateCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '12001',
      name: 'StateRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '12002',
      name: 'StateUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '12003',
      name: 'StateDelete',
      // disabled: true,
    },
  ],
  transaction: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '13000',
      name: 'TransactionCreate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '13001',
      name: 'TransactionRead',
      // disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '13002',
      name: 'TransactionUpdate',
      // disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '13003',
      name: 'TransactionDelete',
      // disabled: true,
    },
  ],
  experimentation: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '17000',
      name: 'ExperimentationCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '17001',
      name: 'ExperimentationRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '17002',
      name: 'ExperimentationUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '17003',
      name: 'ExperimentationDelete',
      disabled: true,
    },
  ],
  oReport: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '18000',
      name: 'OReportCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '18001',
      name: 'TOReportRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '18002',
      name: 'OReportUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '18003',
      name: 'OReportDelete',
      disabled: true,
    },
  ],
  mil: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '19000',
      name: 'MILCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '19001',
      name: 'MILRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '19002',
      name: 'MILUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '19003',
      name: 'MILDelete',
      disabled: true,
    },
  ],
  oAndIncidentChart: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '20000',
      name: 'OAndIncidentChartCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '20001',
      name: 'OAndIncidentChartRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '20002',
      name: 'OAndIncidentChartUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '20003',
      name: 'OAndIncidentChartDelete',
      disabled: true,
    },
  ],
  lill: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '21000',
      name: 'LillCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '21001',
      name: 'LillRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '21002',
      name: 'LillUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '21003',
      name: 'LillDelete',
    },
  ],
  lillObserver: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '21010',
      name: 'LillObserverCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '21011',
      name: 'LillObserverRead',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '21012',
      name: 'LillObserverUpdate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '21013',
      name: 'LillObserverDelete',
      disabled: true,
    },
  ],
  lillProprietor: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '21020',
      name: 'LillProprietor:Create',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '21021',
      name: 'LillProprietor:Read',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '21022',
      name: 'LillProprietorUpdate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '21023',
      name: 'LillProprietorDelete',
      disabled: true,
    },
  ],
  lillAnalyst: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '21030',
      name: 'LillAnalystCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '21031',
      name: 'LillAnalystRead',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '21032',
      name: 'LillAnalystUpdate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '21033',
      name: 'LillAnalystDelete',
      disabled: true,
    },
  ],
  lillTaskingAuthority: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '21040',
      name: 'LillTaskingAuthorityCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '21041',
      name: 'LillTaskingAuthorityRead',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '21042',
      name: 'LillTaskingAuthorityUpdate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '21043',
      name: 'LillTaskingAuthorityDelete',
      disabled: true,
    },
  ],
  lillActionBody: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '21050',
      name: 'LillActionBodyCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '21051',
      name: 'LillActionBodyRead',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '21052',
      name: 'LillActionBodyUpdate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '21053',
      name: 'LillActionBodyDelete',
      disabled: true,
    },
  ],
  actorBooks: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '25000',
      name: 'ActorBooksCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '25001',
      name: 'ActorBooksRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '25002',
      name: 'ActorBooksUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '25003',
      name: 'ActorBooksDelete',
    },
  ],
  geostrategicSituation: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '26000',
      name: 'GeostrategicSituationCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '26001',
      name: 'GeostrategicSituationRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '26002',
      name: 'GeostrategicSituationUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '26003',
      name: 'GeostrategicSituationDelete',
      disabled: true,
    },
  ],
  roadToCurrentSetting: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '27000',
      name: 'RoadToCurrentSettingCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '27001',
      name: 'RoadToCurrentSettingRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '27002',
      name: 'RoadToCurrentSettingUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '27003',
      name: 'RoadToCurrentSettingDelete',
      disabled: true,
    },
  ],
  workPackage: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '28000',
      name: 'WorkPackageCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '28001',
      name: 'WorkPackageRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '28002',
      name: 'WorkPackageUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '28003',
      name: 'WorkPackageDelete',
    },
  ],
  task: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '29000',
      name: 'TaskCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '29001',
      name: 'TaskRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '29002',
      name: 'TaskUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '29003',
      name: 'TaskDelete',
    },
  ],
  projectInput: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '30000',
      name: 'ProjectInputCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '30001',
      name: 'ProjectInputRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '30002',
      name: 'ProjectInputUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '30003',
      name: 'ProjectInputDelete',
    },
  ],
  kanban: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '31000',
      name: 'KanbanCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '31001',
      name: 'KanbanRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '31002',
      name: 'KanbanUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '31003',
      name: 'KanbanDelete',
    },
  ],
  deliverable: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '32000',
      name: 'DeliverableCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '32001',
      name: 'DeliverableRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '32002',
      name: 'DeliverableUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '32003',
      name: 'DeliverableDelete',
    },
  ],
  test: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '33000',
      name: 'TestCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '33001',
      name: 'TestRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '33002',
      name: 'TestUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '33003',
      name: 'TestDelete',
    },
  ],

  hymotse: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '34000',
      name: 'HymotseCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '34001',
      name: 'HymotseRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '34002',
      name: 'HymotseUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '34003',
      name: 'HymotseDelete',
    },
  ],
  fmmState: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '35000',
      name: 'FMMStateCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '35001',
      name: 'FMMStateRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '35002',
      name: 'FMMStateUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '35003',
      name: 'FMMStateDelete',
    },
  ],
  fmmTransaction: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '36000',
      name: 'FMMTransactionCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '36001',
      name: 'FMMTransactionRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '36002',
      name: 'FMMTransactionUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '36003',
      name: 'FMMTransactionDelete',
    },
  ],
  ppmState: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '37000',
      name: 'PPMStateCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '37001',
      name: 'PPMStateRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '37002',
      name: 'PPMStateUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '37003',
      name: 'PPMStateDelete',
    },
  ],
  ppmTransaction: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '38000',
      name: 'PPMTransactionCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '38001',
      name: 'PPMTransactionRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '38002',
      name: 'PPMTransactionUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '38003',
      name: 'PPMTransactionDelete',
    },
  ],
  rlsmState: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '39000',
      name: 'RLSMStateCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '39001',
      name: 'RLSMStateRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '39002',
      name: 'RLSMStateUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '39003',
      name: 'RLSMStateDelete',
    },
  ],
  rlsmTransaction: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '40000',
      name: 'RLSMTransactionCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '40001',
      name: 'RLSMTransactionRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '40002',
      name: 'RLSMTransactionUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '40003',
      name: 'RLSMTransactionDelete',
    },
  ],
  lillState: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '41000',
      name: 'LILLStateCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '41001',
      name: 'LILLStateRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '41002',
      name: 'LILLStateUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '41003',
      name: 'LILLStateDelete',
    },
  ],
  lillTransaction: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '42000',
      name: 'LILLTransactionCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '42001',
      name: 'LILLTransactionRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '42002',
      name: 'LILLTransactionUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '42003',
      name: 'LILLTransactionDelete',
    },
  ],
  phase: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '43000',
      name: 'PhaseCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '43001',
      name: 'PhaseRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '43002',
      name: 'PhaseUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '43003',
      name: 'PhaseDelete',
    },
  ],
  lineOfEffort: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '44000',
      name: 'LOECreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '44001',
      name: 'LOERead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '44002',
      name: 'LOEUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '44003',
      name: 'LOEDelete',
    },
  ],
  planOrderReportProcess: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '45000',
      name: 'PlanOrderReportProcessCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '45001',
      name: 'PlanOrderReportProcessRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '45002',
      name: 'PlanOrderReportProcessUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '45003',
      name: 'PlanOrderReportProcessDelete',
    },
  ],
  decisiveCondition: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '46000',
      name: 'DecisiveConditionsCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '46001',
      name: 'DecisiveConditionsRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '46002',
      name: 'DecisiveConditionsUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '46003',
      name: 'DecisiveConditionsDelete',
    },
  ],
  odTask: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '47000',
      name: 'ODTaskCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '47001',
      name: 'ODTaskRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '47002',
      name: 'ODTaskUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '47003',
      name: 'ODTaskDelete',
    },
  ],
  effect: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '48000',
      name: 'EffectCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '48001',
      name: 'EffectRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '48002',
      name: 'EffectUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '48003',
      name: 'EffectDelete',
    },
  ],
  wargamingTurnChart: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '49000',
      name: 'WargamingTurnChartCreate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '49001',
      name: 'WargamingTurnChartRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '49002',
      name: 'WargamingTurnChartUpdate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '49003',
      name: 'WargamingTurnChartDelete',
      disabled: false,
    },
  ],
  tasksEffectDCReport: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '50000',
      name: 'TasksEffectDCReportCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '50001',
      name: 'TasksEffectDCReportRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '50002',
      name: 'TasksEffectDCReportUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '50003',
      name: 'TasksEffectDCReportDelete',
      disabled: true,
    },
  ],
  operationalDesignReport: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '51000',
      name: 'OperationalDesignReportCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '51001',
      name: 'OperationalDesignReportRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '51002',
      name: 'OperationalDesignReportUpdate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '51003',
      name: 'OperationalDesignReportDelete',
      disabled: true,
    },
  ],
  odc2mState: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '52000',
      name: 'ODC2MStateCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '52001',
      name: 'ODC2MStateRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '52002',
      name: 'ODC2MStateUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '52003',
      name: 'ODC2MStateDelete',
    },
  ],
  odc2mTransaction: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '53000',
      name: 'ODC2MTransactionCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '53001',
      name: 'ODC2MTransactionRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '53002',
      name: 'ODC2MTransactionUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '53003',
      name: 'ODC2MTransactionDelete',
    },
  ],
  ppmProject: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '54000',
      name: 'PPMProjectCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '54001',
      name: 'PPMProjectRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '54002',
      name: 'PPMProjectUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '54003',
      name: 'PPMProjectDelete',
    },
  ],

  coamCoaDevelopment: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '55000',
      name: 'COAMCoaDevelopmentCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '55001',
      name: 'COAMCoaDevelopmentRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '55002',
      name: 'COAMCoaDevelopmentUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '55003',
      name: 'COAMCoaDevelopmentDelete',
    },
  ],

  coamSyncMatrix: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '56000',
      name: 'COAMSyncMatrixCreate',
      disabled: true,
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '56001',
      name: 'COAMSyncMatrixRead',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '56002',
      name: 'COAMSyncMatrixUpdate',
      disabled: false,
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '56003',
      name: 'COAMSyncMatrixDelete',
      disabled: true,
    },
  ],

  coamRisk: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '57000',
      name: 'COAMRiskCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '57001',
      name: 'COAMRiskRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '57002',
      name: 'COAMRiskUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '57003',
      name: 'COAMRiskDelete',
    },
  ],
  coamCoaAnalysis: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '58000',
      name: 'COAMCoaAnalysisCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '58001',
      name: 'COAMCoaAnalysisRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '58002',
      name: 'COAMCoaAnalysisUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '58003',
      name: 'COAMCoaAnalysisDelete',
    },
  ],
  ommState: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '59000',
      name: 'OMMStateCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '59001',
      name: 'OMMStateRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '59002',
      name: 'OMMStateUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '59003',
      name: 'OMMStateDelete',
    },
  ],
  ommTransaction: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '60000',
      name: 'OMMTransactionCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '60001',
      name: 'OMMTransactionRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '60002',
      name: 'OMMTransactionUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '60003',
      name: 'OMMTransactionDelete',
    },
  ],
  odc2mRisk: [
    {
      label: t('administration.userRights.permissions.add'),
      value: '61000',
      name: 'ODC2MRiskCreate',
    },
    {
      label: t('administration.userRights.permissions.read'),
      value: '61001',
      name: 'ODC2MRiskRead',
    },
    {
      label: t('administration.userRights.permissions.modify'),
      value: '61002',
      name: 'ODC2MRiskUpdate',
    },
    {
      label: t('administration.userRights.permissions.delete'),
      value: '61003',
      name: 'ODC2MRiskDelete',
    },
  ],
});
